import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import back_n from "../Tutorials/Image/back_n.gif";
import back_o from "../Tutorials/Image/back_o.gif";
import back_d from "../Tutorials/Image/back_d.gif";
import principle_n from "../Tutorials/Image/principle_n.gif";
import tutorials_n from "../Tutorials/Image/tutorials_n.gif";
import clue_n from "../Tutorials/Image/clue_n.gif";
import solution_n from "../Tutorials/Image/solution_n.gif";
import solution_o from "../Tutorials/Image/solution_o.gif";
import solution_d from "../Tutorials/Image/solution_d.gif";
import next_n from "../Tutorials/Image/next_n.gif";
import next_o from "../Tutorials/Image/next_o.gif";
import next_d from "../Tutorials/Image/next_d.gif";
import ok_n from "../Tutorials/Image/ok_n.gif";
import ok_o from "../Tutorials/Image/ok_o.gif";
import ok_d from "../Tutorials/Image/ok_d.gif";
import done_o from "../Tutorials/Image/done_o.gif";
import done_n from "../Tutorials/Image/done_n.gif";
import x_close_btn_n from "../Tutorials/Image/x_close_btn_n.png";
import x_close_btn_o from "../Tutorials/Image/x_close_btn_o.png";
import next_step_btn_n from "../Tutorials/Image/next_step_btn_n.png";
import next_step_btn_o from "../Tutorials/Image/next_step_btn_o.png";
import got_it_btn_n from "../Tutorials/Image/got_it_btn_n.png";
import got_it_btn_o from "../Tutorials/Image/got_it_btn_o.png";
import './Style/Question.css';
import Loading from "../../Common/Loading";
import { buildNextQuestionData, buildShuffledQuestionsOrder, saveQuestionPerformance, QuestionPerformancePayload } from '../../services/questionApi';
import { useViewLessonPreview } from './hooks/useViewLessonPreview';
import { renderRfcRfic } from './utils/rfcRficUtil';
import useIframeEnterKey from '../../Common/Tutorials/useIframeEnterKey';

export interface AnswerRef {
    getAnswer: () => {
        marks: number;
        noOfOptions: number;
        enteredCorrectAnswer: string;
        enteredWrongAnswer: string;
        enteredBlankAnswer: string;
        scoringMethod?: number | null;
        optOrder?: string;
    } | null;
}

interface NQnsProps {
    lessonMeta?: any;
    questionHtml: string;
    currentPage: number;
    totalPages: number;
    goToNextPage?: (e: React.MouseEvent) => void;
    showAlert: (message: string) => void;
    correctAudio: string[];
    incorrectAudio: string[];
    assetsBaseUrl?: string;
    sessionId: number | null;
    isCompleting?: boolean;
    updateSessionPoints?: (pointsEarned: number) => void;
    hwid?: number | null;
    subject?: string;
    previewMode?: string | null;
}

const NQns: React.ForwardRefRenderFunction<AnswerRef, NQnsProps> = (props, ref) => {
    const { lessonMeta, questionHtml, currentPage, totalPages, goToNextPage, showAlert, correctAudio, incorrectAudio, assetsBaseUrl, sessionId, isCompleting, updateSessionPoints, hwid, subject, previewMode } = props;
    const navigate = useNavigate();
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const solnIframeRef = useRef<HTMLIFrameElement>(null);

    const [backSrc, setBackSrc] = useState(back_n);
    const [nextSrc, setNextSrc] = useState(next_n);
    const [okSrc, setOkSrc] = useState(ok_n);
    const [doneSrc, setDoneSrc] = useState(done_n);
    const [solutionSrc, setSolutionSrc] = useState(solution_n);
    const [CloseBtnSrc, setCloseBtnSrc] = useState(x_close_btn_n);
    const [NextStepBtnSrc, setNextStepBtnSrc] = useState(next_step_btn_n);
    const [GotItBtnSrc, setGotItBtnSrc] = useState(got_it_btn_n);

    const [okClicked, setOkClicked] = useState(false);
    const [answers, setAnswers] = useState<Record<string, string>>({});
    const [currentQnMeta, setCurrentQnMeta] = useState<any | null>(null);
    const [explanation, setExplanation] = useState("");

    const [showClueModal, setShowClueModal] = useState(false);
    const [clueContent,
        setClueContent
    ] = useState('');
    const [isClueLoading,
        setIsClueLoading
    ] = useState(false);
    const clueIframeRef = useRef<HTMLIFrameElement>(null);
    const prcIframeRef = useRef<HTMLIFrameElement>(null);
    const [noOfClues, setNoOfClues] = useState(0);
    const [currentClueNo, setCurrentClueNo] = useState(0);
    const [clueSeen, setClueSeen] = useState(false);
    const [showPrcModal, setShowPrcModal] = useState(false);
    const [prcContent,
        setPrcContent
    ] = useState("");
    const [isPrcLoading,
        setIsPrcLoading
    ] = useState(false);
    const [prcSeen, setPrcSeen] = useState(false);
    const [principleList, setPrincipleList] = useState<string[]>([]);
    const [currentPrcIndex, setCurrentPrcIndex] = useState(0);

    const [showSolnModal, setShowSolnModal] = useState(false);
    const [isSolnLoading,
        setIsSolnLoading
    ] = useState(false);
    const [solnContent,
        setSolnContent
    ] = useState("");
    const [solutionSeen, setSolutionSeen] = useState<string | number>('N');
    const [currentSolnNo, setCurrentSolnNo] = useState(0);
    const [revealedSolnSteps, setRevealedSolnSteps] = useState<number[]>([]);
    useEffect(() => {
        setCurrentSolnNo(0);
        setRevealedSolnSteps([]);
    }, [currentQnMeta?.QnNo]);
    const [noOfSteps, setNoOfSteps] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const folderParam = params.get('folder');
    const lessonName = params.get('name');
    const diccode = params.get('diccode');
    const calledFrom = params.get('calledFrom') || params.get('CalledFrom');
    const [startTime, setStartTime] = useState<Date | null>(null);
    const isInAssessment = window.location.href.includes('Assessment');

    const handleNextStepBtnMouseOver = () => setNextStepBtnSrc(next_step_btn_o);
    const handleNextStepBtnMouseOut = () => setNextStepBtnSrc(next_step_btn_n);
    const handleGotItBtnMouseOver = () => setGotItBtnSrc(got_it_btn_o);
    const handleGotItBtnMouseOut = () => setGotItBtnSrc(got_it_btn_n);
    const handleCloseBtnMouseOver = () => setCloseBtnSrc(x_close_btn_o);
    const handleCloseBtnMouseOut = () => setCloseBtnSrc(x_close_btn_n);
    const handleBackMouseOver = () => setBackSrc(back_o);
    const handleBackMouseOut = () => setBackSrc(back_n);
    const handleBackMouseDown = () => setBackSrc(back_d);
    const handleBackMouseUp = () => setBackSrc(back_o);
    const handleNextMouseOver = () => setNextSrc(next_o);
    const handleNextMouseOut = () => setNextSrc(next_n);
    const handleNextMouseDown = () => setNextSrc(next_d);
    const handleNextMouseUp = () => setNextSrc(next_o);
    const handleOkMouseOver = () => setOkSrc(ok_o);
    const handleOkMouseOut = () => setOkSrc(ok_n);
    const handleOkMouseDown = () => setOkSrc(ok_d);
    const handleOkMouseUp = () => setOkSrc(ok_o);
    const handleSolutionMouseOver = () => setSolutionSrc(solution_o);
    const handleSolutionMouseOut = () => setSolutionSrc(solution_n);
    const handleSolutionMouseDown = () => setSolutionSrc(solution_d);
    const { isViewLesson, isAnswerMode, isSolutionMode, isPreview, guardSave, handleDoneClick } = useViewLessonPreview(previewMode);
    // The hook may not know about RFC/RFIC, so cover it here.
    const isPreviewLocal = isPreview || (params.get('ViewLesson') === 'Y' && previewMode === 'RFC_RFIC');

    const handleClueClick = useCallback(async () => {
        if (!currentQnMeta || !lessonMeta) return;
        setShowClueModal(true);
        setIsClueLoading(true);
        setClueContent("");
        setCurrentClueNo(0);
        setNoOfClues(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = params.get('country') || 'Australia';
        const varValuesParam = currentQnMeta?.VarValues || "";

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsClueLoading(false);
            setShowClueModal(false);
            return;
        }

        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

        try {
            const response = await fetch(`${apiUrl}clue/`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    folder: folderParam,
                    questionNo: currentQnMeta.QnNo,
                    country: countryParam,
                    varValues: varValuesParam,
                }),
            });

            if (!response.ok) {
                if (response.status === 404) setClueContent("");
                else if (response.status === 401 || response.status === 403) showAlert("Authentication failed.");
                throw new Error(`HTTP error! status: ${response.status}`);
            } else {
                const data = await response.json();
                setClueContent(data.clueHtml || "");
                setClueSeen(true);
            }
        } catch (error) {
            console.error("Error fetching clue:", error);
            if (!(error instanceof Error && (error.message.includes("401") || error.message.includes("403") || error.message.includes("404")))) {
                showAlert("Failed to load the clue.");
            }
            setClueContent("");
        } finally {
            setIsClueLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, params]);

    const fetchPrincipleContent = async (principleId: string, folderParam: string, countryParam: string) => {
        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

        const response = await fetch(`${apiUrl}principle/`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                folder: folderParam,
                questionNo: principleId,
                country: countryParam,
            }),
        });

        if (!response.ok) throw new Error("Failed");
        return await response.json();
    };

    const handlePrcClick = useCallback(async () => {
        if (!currentQnMeta || !lessonMeta) return;

        const prcString = currentQnMeta.PrincipleNos || "";
        const prcIds = prcString.replace(/"/g, "").split(',').filter((s: string) => s.trim() !== "");

        if (prcIds.length === 0) {
            if ((currentQnMeta.NoOfPrc || 0) > 0) {
                prcIds.push("1");
            } else {
                showAlert("No principles found for this question.");
                return;
            }
        }

        setShowPrcModal(true);
        setIsPrcLoading(true);
        setPrcContent("");
        setPrincipleList(prcIds);
        setCurrentPrcIndex(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = params.get('country') || 'Australia';

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsPrcLoading(false);
            setShowPrcModal(false);
            return;
        }

        try {
            const data = await fetchPrincipleContent(prcIds[0], folderParam, countryParam);
            setPrcContent(data.principleHtml || "");
            setPrcSeen(true);
        } catch (error) {
            console.error("Error fetching principle:", error);
            setPrcContent("");
        } finally {
            setIsPrcLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, params]);


    const handleSolnClick = useCallback(async (autoExpand = false) => {
        if (!currentQnMeta || !lessonMeta) return;

        setShowSolnModal(true);
        setIsSolnLoading(true);
        setSolnContent("");
        setNoOfSteps(0);

        const searchParams = new URLSearchParams(window.location.search);
        const folderParam = searchParams.get('folder');
        const countryParam = searchParams.get('country') || 'Australia';

        if (!folderParam) {
            showAlert("Could not determine the lesson folder.");
            setIsSolnLoading(false);
            setShowSolnModal(false);
            return;
        }

        const accessToken = localStorage.getItem('access_token');
        const headers: HeadersInit = { 'Content-Type': 'application/json' };
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        } else {
            console.warn("Access token not found in localStorage.");
        }

        const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

        try {
            const response = await fetch(`${apiUrl}solution/`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    folder: folderParam,
                    questionNo: currentQnMeta.QnNo,
                    country: countryParam,
                    autoExpand: autoExpand,
                }),
            });

            // No solution file for this question.
            if (response.status === 404) {
                setShowSolnModal(false);
                showAlert("No solution found for this question.");
                return;
            }

            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    showAlert("Authentication failed. Please log in again.");
                }
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            // 200 with an error body or empty solution.
            if (data?.error || !data?.solutionHtml) {
                setShowSolnModal(false);
                showAlert("No solution found for this question.");
                return;
            }

            setSolnContent(data.solutionHtml);
            if (solutionSeen === 'N') {
                setSolutionSeen(1);
            }

        } catch (error) {
            console.error("Error fetching solution:", error);
            if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403")))) {
                showAlert("Failed to load the solution. Please try again.");
            }
            setShowSolnModal(false);
        } finally {
            setIsSolnLoading(false);
        }
    }, [currentQnMeta, lessonMeta, showAlert, solutionSeen]);

    // Keeps the latest handleSolnClick available to the preview onLoad.
    const handleSolnClickRef = useRef(handleSolnClick);
    useEffect(() => {
        handleSolnClickRef.current = handleSolnClick;
    }, [handleSolnClick]);

    useEffect(() => {
        setOkClicked(false);
        setAnswers({});
        setSolutionSeen('N');
        setClueSeen(false);
        setPrcSeen(false);
        setStartTime(new Date());
        setExplanation("");
        if (lessonMeta && Array.isArray(lessonMeta.qns) && currentPage <= lessonMeta.qns.length) {
            setCurrentQnMeta(lessonMeta.qns[currentPage - 1]);
        } else {
            setCurrentQnMeta(null);
        }
    }, [currentPage, questionHtml, lessonMeta]);

    const injectNumberPadBridge = (html: string): string => {
        /*
         * IMPORTANT:
         * The question HTML comes from the old VB application and contains
         * inline handlers such as:
         *   onclick="insertDigit('7')"
         *   onmouseup="hideF()"
         *   onchange="fn_SetSize(...)"
         *   onkeypress="fn_Jump2NextBlank(...)"
         *
         * Those functions lived in the old ASPX JavaScript files. They are
         * intentionally NOT loaded into the React iframe.
         *
         * Therefore:
         *  1. Convert number-pad onclick handlers to data attributes.
         *  2. Remove ALL legacy inline event handlers.
         *  3. Remove old scripts.
         *  4. Bind the required events directly with normal JavaScript.
         *
         * Never put TypeScript syntax such as "as HTMLInputElement" or
         * "(window as any)" inside this iframe script. The iframe executes
         * plain JavaScript, not TypeScript.
         */

        let cleaned = html
            // Convert the old number-pad command BEFORE removing onclick.
            .replace(
                /onclick\s*=\s*(['"])\s*insertDigit\(\s*(['"])(.*?)\2\s*\)\s*\1/gi,
                (_match, _attrQuote, _argQuote, digit) =>
                    `data-insert-digit="${digit}"`
            )
            // Remove every remaining legacy inline event handler.
            // This removes onmouseup="hideF(...)", onmousemove="...",
            // onchange="fn_SetSize(...)" and onkeypress="fn_Jump2NextBlank(...)".
            .replace(
                /\s+on[a-z]+\s*=\s*(?:"[^"]*"|'[^']*')/gi,
                ""
            )
            // Remove legacy external/inline scripts from the question.
            .replace(/<script[\s\S]*?<\/script>/gi, "")
            .replace(
                /(<textarea[^>]*id="KSD_W"[^>]*)\s+style="[^"]*"/gi,
                "$1"
            );

        const bridge = `
            <style>
                html, body {
                    width: 100%;
                    height: 100%;
                    margin: 0;
                    padding: 0;
                    background-color: #ffffff !important;
                }

                p {
                    margin: 0;
                    padding: 0;
                }

                body > table:first-of-type {
                    width: 100% !important;
                    height: 100% !important;
                    border-collapse: collapse;
                }

                body > table:first-of-type > tbody > tr:first-child > td:first-child {
                    width: 100% !important;
                    background-color: #ffffff !important;
                }

                #KSD_TABLE {
                    width: 100% !important;
                    max-width: none !important;
                    margin: 0 !important;
                    background: #ffffff !important;
                }

                #KSD_TABLE,
                #KSD_TABLE td,
                #KSD_TABLE th {
                    background: #ffffff !important;
                }

                input[id^="KSD_BLANK_"] {
                    caret-color: black;
                    text-align: center !important;
                    font-weight: bold;
                    font-size: 24pt !important;
                    font-family: "Courier New", Courier, monospace;
                    border-left-style: none;
                    border-top-style: none;
                    border-right-style: none;
                    border-bottom: 2px solid red;
                    background-color: transparent;
                    border-radius: 0;
                    color: red !important;
                }

                input[id^="KSD_BLANK_"]:focus {
                    outline: 1px dashed red;
                    border: 2px solid;
                    border-bottom: none !important;
                    outline-offset: 2px;
                    background-color: #E6E9EC !important;
                }

                input[id^="TXT_CARRY_"] {
                    color: rgb(153, 187, 204) !important;
                    font-family: Arial, Helvetica, sans-serif !important;
                    font-size: 15pt !important;
                    border: 1px dashed rgb(0, 0, 0) !important;
                    width: 80% !important;
                    text-align: center !important;
                    background-color: rgb(255, 255, 255) !important;
                    padding: 0 !important;
                    margin: 0 auto !important;
                    display: block !important;
                    height: auto !important;
                    border-radius: 0 !important;
                }

                input[id^="TXT_CARRY_"]:focus {
                    outline: none !important;
                    box-shadow: none !important;
                    background-color: #E6E9EC !important;
                    border: 1px dashed #F15B2A !important;
                }

                #KSD_NUMPAD img[data-insert-digit] {
                    cursor: pointer;
                    user-select: none;
                    -webkit-user-select: none;
                    -webkit-user-drag: none;
                }

                body > table:first-of-type td {
                    vertical-align: top;
                }
            </style>

            <script>
                (function () {
                    function initNumberPad() {
                        try {
                            var questionTable = document.getElementById('KSD_TABLE');

                            if (questionTable) {
                                questionTable.style.setProperty('width', '100%', 'important');
                                questionTable.style.setProperty('max-width', 'none', 'important');
                                questionTable.style.setProperty('margin', '0', 'important');
                                questionTable.style.setProperty('background', '#ffffff', 'important');

                                var wrapper = questionTable.parentElement;

                                for (var level = 0; wrapper && level < 2; level += 1) {
                                    wrapper.style.setProperty('background', '#ffffff', 'important');
                                    wrapper.style.setProperty('width', '100%', 'important');
                                    wrapper = wrapper.parentElement;
                                }

                                questionTable.querySelectorAll('td, th').forEach(function (cell) {
                                    cell.style.setProperty('background', '#ffffff', 'important');
                                });
                            }

                            var firstTd = document.querySelector(
                                'body > table:first-of-type > tbody > tr:first-child > td:first-child'
                            );

                            if (firstTd) {
                                firstTd.style.padding = '5px';
                            }

                            var dividerBar = document.getElementById('KSD_DIVIDERBAR');

                            if (dividerBar) {
                                dividerBar.style.paddingLeft = '0px';
                                dividerBar.style.paddingTop = '0px';
                                dividerBar.style.paddingBottom = '0px';
                            }

                            var numPadCell = document.getElementById('KSD_NUMPAD');

                            if (numPadCell) {
                                numPadCell.style.padding = '0px';
                            }

                            var numPadContainer = document.getElementById('KSD_NUMPAD');
                            var innerTable = null;

                            if (numPadContainer) {
                                innerTable = numPadContainer.querySelector('table');
                            } else {
                                var numPadButton = document.querySelector('[data-insert-digit]');

                                if (numPadButton) {
                                    innerTable = numPadButton.closest('table');
                                }
                            }

                            if (innerTable) {
                                innerTable.style.margin = '0px';
                                innerTable.style.marginTop = '0px';
                                innerTable.style.borderSpacing = '0px';
                                innerTable.setAttribute('cellpadding', '0');

                                if (innerTable.rows.length > 0) {
                                    var firstButtonRow = innerTable.rows[0];
                                    var numCols = firstButtonRow.cells.length;
                                    var labelRow = innerTable.insertRow(0);
                                    var labelCell = labelRow.insertCell(0);

                                    labelCell.textContent = 'Number pad:';
                                    labelCell.style.paddingBottom = '10px';
                                    labelCell.style.fontFamily = 'arial';
                                    labelCell.style.fontSize = '24pt';
                                    labelCell.style.color = '#3c5168';
                                    labelCell.style.fontWeight = 'normal';
                                    labelCell.style.textAlign = 'left';

                                    if (numCols > 1) {
                                        labelCell.colSpan = numCols;
                                    }
                                }
                            }
                        } catch (e) {
                            console.error('Error adding number pad label:', e);
                        }

                        try {
                            var infoElement = document.getElementById('KSD_MW_Info');
                            var infoVal = infoElement ? infoElement.value : '';
                            var parts = infoVal.split('|');

                            var fgColor = parts[1] || 'red';
                            var blankWidthFit = parts[2];

                            var bwElement = document.getElementById('KSD_BW');
                            var bwVal = bwElement ? bwElement.value : '';
                            var correctAnswers = bwVal.split('|');

                            var activeInput = null;

                            var allInputs = Array.prototype.slice.call(
                                document.querySelectorAll(
                                    'input[id^="KSD_BLANK_"], input[id^="TXT_CARRY_"]'
                                )
                            );

                            var inputs = allInputs.sort(function (a, b) {
                                var isCarryA = a.id.indexOf('TXT_CARRY_') === 0;
                                var isCarryB = b.id.indexOf('TXT_CARRY_') === 0;

                                if (isCarryA && !isCarryB) return -1;
                                if (!isCarryA && isCarryB) return 1;

                                var matchA = a.id.match(/\\d+/);
                                var matchB = b.id.match(/\\d+/);

                                var idA = matchA ? parseInt(matchA[0], 10) : 0;
                                var idB = matchB ? parseInt(matchB[0], 10) : 0;

                                return idA - idB;
                            });

                            function setActiveInput(input) {
                                if (!input) return;

                                activeInput = input;

                                inputs.forEach(function (item) {
                                    item.classList.remove('active-input');
                                });

                                input.classList.add('active-input');
                            }

                            if (inputs.length > 0) {
                                setActiveInput(inputs[0]);
                            }

                            inputs.forEach(function (input, index) {
                                if (input.id.indexOf('KSD_BLANK_') === 0) {
                                    input.style.color = fgColor;
                                }

                                if (blankWidthFit === '0') {
                                    input.maxLength = 200000;
                                } else if (
                                    blankWidthFit === '1' &&
                                    correctAnswers[index]
                                ) {
                                    input.maxLength = correctAnswers[index].length;
                                }

                                input.addEventListener('focus', function () {
                                    setActiveInput(input);
                                });

                                input.addEventListener('input', function () {
                                    var allAnswers = {};

                                    inputs.forEach(function (inp) {
                                        allAnswers[inp.id] = inp.value;
                                    });

                                    parent.postMessage(
                                        {
                                            type: 'el-fillin-answers',
                                            value: allAnswers
                                        },
                                        '*'
                                    );

                                    var currentIndex = inputs.indexOf(input);

                                    if (
                                        input.maxLength > 0 &&
                                        input.value.length >= input.maxLength &&
                                        currentIndex < inputs.length - 1
                                    ) {
                                        inputs[currentIndex + 1].focus();
                                    }
                                });
                            });

                            /*
                             * ROBUST NUMBER PAD:
                             * The old HTML's onclick="insertDigit(...)" is gone.
                             * Each button now has data-insert-digit and receives
                             * a real event listener in this document.
                             */
                            var numberPadButtons = Array.prototype.slice.call(
                                document.querySelectorAll('[data-insert-digit]')
                            );

                            numberPadButtons.forEach(function (button) {
                                button.addEventListener('click', function (event) {
                                    event.preventDefault();
                                    event.stopPropagation();

                                    try {
                                        if (!activeInput || !document.body.contains(activeInput)) {
                                            if (inputs.length > 0) {
                                                setActiveInput(inputs[0]);
                                            }
                                        }

                                        if (!activeInput) return;

                                        var digit = button.getAttribute('data-insert-digit') || '';

                                        if (!digit) return;

                                        if (digit === '←') {
                                            activeInput.value = activeInput.value.slice(0, -1);
                                        } else if (
                                            activeInput.maxLength === -1 ||
                                            activeInput.value.length < activeInput.maxLength
                                        ) {
                                            activeInput.value += digit;
                                        } else {
                                            activeInput.value = digit;
                                        }

                                        activeInput.dispatchEvent(
                                            new Event('input', { bubbles: true })
                                        );

                                        activeInput.focus();
                                    } catch (e) {
                                        console.error('Number Pad Input Error:', e);
                                    }
                                });
                            });
                        } catch (e) {
                            console.error('Bridge Error:', e);
                        }
                    }

                    if (document.readyState === 'loading') {
                        document.addEventListener('DOMContentLoaded', initNumberPad);
                    } else {
                        initNumberPad();
                    }
                })();
            </script>
        `;

        return cleaned.includes("</body>")
            ? cleaned.replace("</body>", bridge + "</body>")
            : cleaned + bridge;
    };

    useEffect(() => {
        const iframe = iframeRef.current;
        if (iframe && questionHtml) {
            iframe.srcdoc = injectNumberPadBridge(questionHtml);
        }
    }, [questionHtml]);

    useImperativeHandle(ref, () => ({
        getAnswer: () => {
            const iframeDoc = iframeRef.current?.contentDocument;
            if (!iframeDoc) return null;

            const carries = Array.from(iframeDoc.querySelectorAll('input[id^="TXT_CARRY_"]')).sort((a, b) => {
                const idA = parseInt(a.id.replace('TXT_CARRY_', '')) || 0;
                const idB = parseInt(b.id.replace('TXT_CARRY_', '')) || 0;
                return idA - idB;
            });

            const blanks = Array.from(iframeDoc.querySelectorAll('input[id^="KSD_BLANK_"]')).sort((a, b) => {
                const idA = parseInt(a.id.replace('KSD_BLANK_', '')) || 0;
                const idB = parseInt(b.id.replace('KSD_BLANK_', '')) || 0;
                return idA - idB;
            });

            const targets = [...carries, ...blanks];

            const correctAnsEl = iframeDoc.querySelector("#KSD_BW") as HTMLInputElement | null;
            if (!correctAnsEl) {
                showAlert("Could not find answer key.");
                return null;
            }
            const correctAnswers = correctAnsEl.value.split('|');

            const answeredCount = Object.values(answers).filter(ans => ans?.toString().trim() !== '').length;

            if (answeredCount < blanks.length && answeredCount === 0) {
                showAlert("Please answer the question.");
                return null;
            }

            let correctCount = 0;
            const enteredCorrect: string[] = [];
            const enteredWrong: string[] = [];

            targets.forEach((element, index) => {
                if (index >= correctAnswers.length) return;

                const userAnswer = answers[element.id]?.trim() || (element as HTMLInputElement).value.trim() || '';
                const correctAnswer = correctAnswers[index]?.trim();

                if (userAnswer.toLowerCase() === correctAnswer.toLowerCase()) {
                    correctCount++;
                    enteredCorrect.push(userAnswer);
                } else {
                    enteredWrong.push(userAnswer);
                }
            });

            const allCorrect = correctCount === targets.length;
            const marks = allCorrect ? 1 : 0;

            return {
                marks,
                noOfOptions: targets.length,
                enteredCorrectAnswer: enteredCorrect.join('|'),
                enteredWrongAnswer: enteredWrong.join('|'),
                enteredBlankAnswer: "",
                optOrder: "",
                scoringMethod: null
            };
        }
    }));

    const playRandomSound = useCallback(async (soundFiles: string[], folder: 'Correct' | 'Incorrect') => {
        const baseUrl = assetsBaseUrl || "https://www.elearnoncloud.com/Storage/assets/";
        if (!soundFiles || soundFiles.length === 0) return;
        const fileName = soundFiles[Math.floor(Math.random() * soundFiles.length)];
        const audioUrl = `${baseUrl}Audio/Question/${folder}/${fileName}`;
        const audio = new Audio(audioUrl);
        try { await audio.play(); } catch (error) { console.error(`Error playing audio from ${audioUrl}:`, error); }
    }, [assetsBaseUrl]);

    const handleDbUpdate = useCallback(guardSave((payload: QuestionPerformancePayload) => {
        return saveQuestionPerformance(payload)
            .then((data) => { if (isCompleting && updateSessionPoints) updateSessionPoints(data.pointsEarned || 0); return data; })
            .catch((error) => { console.error("Save Performance Error:", error); throw error; });
    }), [isCompleting, updateSessionPoints, guardSave]);

    const handleOkClick = useCallback(async (e: React.MouseEvent<any>) => {
        e.preventDefault();
        if (okClicked || isSubmitting) return;
        const iframe = iframeRef.current;

        // Logic to determine if this is the final submit
        const isLastQuestion = currentPage === totalPages;

        if (!iframe?.contentDocument) return;
        const iframeDoc = iframe.contentDocument;

        const carries = Array.from(iframeDoc.querySelectorAll('input[id^="TXT_CARRY_"]')).sort((a, b) => {
            const idA = parseInt(a.id.replace('TXT_CARRY_', '')) || 0;
            const idB = parseInt(b.id.replace('TXT_CARRY_', '')) || 0;
            return idA - idB;
        });
        const blanks = Array.from(iframeDoc.querySelectorAll('input[id^="KSD_BLANK_"]')).sort((a, b) => {
            const idA = parseInt(a.id.replace('KSD_BLANK_', '')) || 0;
            const idB = parseInt(b.id.replace('KSD_BLANK_', '')) || 0;
            return idA - idB;
        });
        const targets = [...carries, ...blanks];

        const correctAnsEl = iframeDoc.querySelector("#KSD_BW") as HTMLInputElement | null;
        if (!correctAnsEl) {
            showAlert("Could not find answer key.");
            return;
        }
        const correctAnswers = correctAnsEl.value.split('|');

        const hasMainAnswers = blanks.some(b => answers[b.id]?.trim() || (b as HTMLInputElement).value.trim());

        if (blanks.length > 0 && !hasMainAnswers) {
            showAlert("Please answer the question.");
            return;
        }

        let mainCorrectCount = 0;
        const blanksOffset = carries.length;
        blanks.forEach((element, i) => {
            const indexInTargets = blanksOffset + i;
            const el = element as HTMLInputElement;
            const userAnswer = answers[el.id]?.trim() || el.value.trim() || '';
            const correctAnswer = correctAnswers[indexInTargets]?.trim();
            if (userAnswer.toLowerCase() === correctAnswer.toLowerCase()) {
                mainCorrectCount++;
            }
        });
        const allMainCorrect = mainCorrectCount === blanks.length;
        const marks = allMainCorrect ? 1 : 0;

        const enteredCorrect: string[] = [];
        const enteredWrong: string[] = [];
        targets.forEach((element, index) => {
            const userAnswer = answers[element.id]?.trim() || (element as HTMLInputElement).value.trim() || '';
            const correctAnswer = correctAnswers[index]?.trim();
            if (userAnswer.toLowerCase() === correctAnswer.toLowerCase()) {
                enteredCorrect.push(userAnswer);
            } else {
                enteredWrong.push(userAnswer);
            }
        });

        const noOfOptions = targets.length;
        const questionAnswerTime = startTime ? Math.floor((new Date().getTime() - startTime.getTime()) / 1000) : 0;
        const schoolCode = sessionStorage.getItem('SchoolCode') || '';
        const familyCode = sessionStorage.getItem('FamilyCode') || '';
        const login = sessionStorage.getItem('Login') || '';
        const chapterCode = sessionStorage.getItem('ChapterCode') || '';
        const unitCode = sessionStorage.getItem('UnitCode') || '';

        const payload: QuestionPerformancePayload = {
            schoolCode,
            familyCode,
            login,
            dicCode: sessionStorage.getItem('SelectedDICFile') || '',
            lsnTestCode: sessionStorage.getItem('LsnTestCode') || '',
            sessionId: sessionId || 1,
            qnNo: currentQnMeta?.QnNo,
            subNo: 0,
            qnType: currentQnMeta?.QnType,
            marks: marks,
            noOfOptions: noOfOptions,
            enteredCorrectAnswer: enteredCorrect.join('|'),
            enteredWrongAnswer: enteredWrong.join('|'),
            enteredBlankAnswer: "",
            solutionSeen: (typeof solutionSeen === 'number' && solutionSeen > 0) || solutionSeen === 'Y' ? 'Y' : 'N',
            clueSeen: clueSeen,
            principleSeen: prcSeen,
            questionLoadTime: 0,
            questionAnswerTime: questionAnswerTime,
            lastQnInd: currentQnMeta?.LastQnInd || currentPage,
            nextQnData: buildNextQuestionData(lessonMeta?.qns, currentPage),
            dbgShuffledQnsOrder: buildShuffledQuestionsOrder(lessonMeta?.qns),
            allQuestionsCompleted: isCompleting ? 'True' : 'False',
            chapterCode: chapterCode,
            unitCode: unitCode,
            hwid: hwid,
            subject: subject
        };

        // --- NEW ASYNC LOGIC START ---
        if (isLastQuestion) {
            setIsSubmitting(true);
            try {
                await handleDbUpdate(payload);
            } catch (e) {
                console.error("Final submit failed", e);
                showAlert("Error saving progress. Please try again.");
                setIsSubmitting(false);
                return;
            }
            setIsSubmitting(false);
        } else {
            // Fire and forget for intermediate questions
            handleDbUpdate(payload).catch(e => console.error("Background save failed", e));
        }
        // --- NEW ASYNC LOGIC END ---

        targets.forEach((element, index) => {
            const el = element as HTMLInputElement;
            const userAnswer = answers[el.id]?.trim() || el.value.trim() || '';
            const correctAnswer = correctAnswers[index]?.trim();
            const isEntryCorrect = userAnswer.toLowerCase() === correctAnswer.toLowerCase();

            const isCarry = el.id.startsWith('TXT_CARRY_');
            let fontSize = '';
            let fontFamily = 'Arial, Helvetica, sans-serif';
            let width = '50px';

            if (isCarry) {
                fontSize = '15pt';
                width = '80%';
            }
            const span = iframeDoc.createElement('span');
            span.style.display = 'inline-block';
            span.style.height = isCarry ? 'auto' : '30px';
            span.style.verticalAlign = 'middle';
            span.style.fontFamily = fontFamily;
            span.style.textAlign = 'center';
            span.style.width = width;

            if (fontSize) span.style.fontSize = fontSize;
            if (!isCarry) span.style.borderBottom = '2px solid red';
            let feedbackHtml = '';
            const fontStyle = fontSize ? `font-size: ${fontSize};` : '';

            if (isCarry) {
                feedbackHtml = `<span style="color: black; font-weight: bold; ${fontStyle} font-family: ${fontFamily};">${correctAnswer}</span>`;
            }
            else {
                if (isEntryCorrect) {
                    feedbackHtml = `<span style="color: green; font-weight: bold; ${fontStyle} font-family: ${fontFamily};">${userAnswer}</span>`;
                } else {
                    feedbackHtml = `<span style="color: red; background-color: yellow; text-decoration:line-through; font-weight: normal; ${fontStyle} font-family: ${fontFamily};">${userAnswer}</span>
                                <span style="color: green; font-weight: normal; ${fontStyle} font-family: ${fontFamily};">${correctAnswer}</span>`;
                }
            }
            span.innerHTML = feedbackHtml;
            el.parentNode?.replaceChild(span, el);
        });

        const existingContainer = iframeDoc.getElementById("el-explanation-container");
        if (existingContainer) existingContainer.remove();
        if (allMainCorrect) {
            playRandomSound(correctAudio, 'Correct');
            setExplanation("");
        } else {
            playRandomSound(incorrectAudio, 'Incorrect');

            let dynamicExplanation = "";
            const rsnElements = iframeDoc.querySelectorAll('[id^="TD_Rsn_"]');

            if (rsnElements.length > 0) {
                rsnElements.forEach(el => {
                    const text = el.innerHTML.trim();
                    if (text) {
                        dynamicExplanation += (dynamicExplanation ? "<br/>" : "") + text;
                    }
                });
            }
            if (dynamicExplanation) {
                const container = iframeDoc.createElement("div");
                container.id = "el-explanation-container";
                container.innerHTML = `
                <hr style='height:1px; background-color:#cfcfcf; border:none; margin-top:50px; margin-bottom:30px; margin-left:30px; margin-right:30px;'>
                <p style='font-size:24px; color:#797979; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:20px'>Explanation</p>
                <p style='font-size:24px; color:#000000; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:50px'>
                    ${dynamicExplanation}
                </p>
            `;
                iframeDoc.body.appendChild(container);

                setTimeout(() => {
                    iframeDoc.documentElement.scrollTop = iframeDoc.documentElement.scrollHeight;
                }, 100);
            }

            if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
                handleSolnClick(true);
            }
        }

        setOkClicked(true);
    }, [
        answers, showAlert, handleDbUpdate, correctAudio, incorrectAudio, playRandomSound,
        startTime, lessonMeta, currentQnMeta, currentPage, totalPages, sessionId,
        isCompleting, clueSeen, prcSeen, solutionSeen, isSubmitting, okClicked, hwid, subject
    ]);

    const handleQuestionFrameLoad = useIframeEnterKey(iframeRef, () => {
        iframeRef.current?.ownerDocument.getElementById('imgOK')?.click();
    });

    useEffect(() => {
        const listener = (event: MessageEvent) => {
            if (event.data?.type === "el-fillin-answers") setAnswers(event.data.value);
        };
        window.addEventListener("message", listener);
        return () => window.removeEventListener("message", listener);
    }, []);

    const handlePreviewLoad = () => {
        if (!isPreviewLocal) return;

        const iframeDoc = iframeRef.current?.contentDocument;
        if (!iframeDoc) return;

        try {
            const carries = Array.from(iframeDoc.querySelectorAll('input[id^="TXT_CARRY_"]')).sort((a, b) => {
                const idA = parseInt(a.id.replace('TXT_CARRY_', '')) || 0;
                const idB = parseInt(b.id.replace('TXT_CARRY_', '')) || 0;
                return idA - idB;
            });
            const blanks = Array.from(iframeDoc.querySelectorAll('input[id^="KSD_BLANK_"]')).sort((a, b) => {
                const idA = parseInt(a.id.replace('KSD_BLANK_', '')) || 0;
                const idB = parseInt(b.id.replace('KSD_BLANK_', '')) || 0;
                return idA - idB;
            });
            const targets = [...carries, ...blanks];

            const correctAnsEl = iframeDoc.querySelector("#KSD_BW") as HTMLInputElement | null;
            if (!correctAnsEl) return;
            const correctAnswers = correctAnsEl.value.split('|');

            const revealedAnswers: Record<string, string> = {};

            targets.forEach((element, index) => {
                const el = element as HTMLInputElement;
                const correctAnswer = correctAnswers[index]?.trim() || '';
                revealedAnswers[el.id] = correctAnswer;

                const isCarry = el.id.startsWith('TXT_CARRY_');
                const span = iframeDoc.createElement('span');
                span.style.display = 'inline-block';
                span.style.height = isCarry ? 'auto' : '30px';
                span.style.verticalAlign = 'middle';
                span.style.fontFamily = 'Arial, Helvetica, sans-serif';
                span.style.textAlign = 'center';
                span.style.width = isCarry ? '80%' : '50px';
                if (isCarry) span.style.fontSize = '15pt';
                if (!isCarry) span.style.borderBottom = '2px solid red';

                span.innerHTML = `<span style="color: green; font-weight: bold; font-family: Arial, Helvetica, sans-serif;">${correctAnswer}</span>`;
                el.parentNode?.replaceChild(span, el);
            });

            setAnswers(revealedAnswers);

            // RFC/RFIC: show whatever reasoning text the question contains.
            if (previewMode === 'RFC_RFIC' && !iframeDoc.getElementById("el-explanation-container")) {
                let reasoning = "";
                iframeDoc.querySelectorAll('[id^="TD_Rsn_"]').forEach(el => {
                    const text = el.innerHTML.trim();
                    if (text) reasoning += (reasoning ? "<br/><br/>" : "") + text;
                });

                if (reasoning) {
                    const container = iframeDoc.createElement("div");
                    container.id = "el-explanation-container";
                    container.innerHTML = `
                        <hr style='height:1px; background-color:#cfcfcf; border:none; margin-top:50px; margin-bottom:30px; margin-left:30px; margin-right:30px;'>
                        <p style='font-size:24px; color:#797979; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:20px'>Explanation</p>
                        <p style='font-size:24px; color:#000000; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:50px'>
                            ${reasoning}
                        </p>
                    `;
                    iframeDoc.body.appendChild(container);
                    setTimeout(() => {
                        iframeDoc.documentElement.scrollTop = iframeDoc.documentElement.scrollHeight;
                    }, 100);
                }
            }
        } catch (e) {
            console.error("Error revealing preview answer:", e);
        }

        setOkClicked(true);
        if (isSolutionMode) {
            handleSolnClickRef.current(true);
        }
    };

    const handleBack = () => {
        const calledFrom = params.get("calledFrom") || params.get("CalledFrom");
        if (calledFrom) {
            const redirectPath = decodeURIComponent(calledFrom);
            window.location.href = redirectPath;
        }
        else if (window.history.length > 1) {
            window.history.back();
        }
    };

    return (
        <>
            {!isInAssessment && (
                <tr id="trQnButtons">
                    <td className="QnPanelT">
                        <table id="tabQnNav" className="QnPanel2T" style={{ height: "50px" }}>
                            <tbody>
                                <tr id="trQnOK" className="trQnOKT">
                                    <td id="QnPanelIdT" className="QnPanel">&nbsp;</td>
                                    <td id="QnPanelId2T" className="QnPanel">
                                        <div
                                            onClick={!okClicked ? handleBack : undefined}
                                            style={{ display: okClicked ? 'none' : 'block', cursor: 'pointer' }}
                                        >
                                            <div id="imgbtnBack" className="imgbtnBackT">
                                                <img
                                                    src={backSrc}
                                                    alt="Back"
                                                    onMouseOver={handleBackMouseOver}
                                                    onMouseOut={handleBackMouseOut}
                                                    onMouseDown={handleBackMouseDown}
                                                    onMouseUp={handleBackMouseUp}
                                                    className="imgbtnBack2T"
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td id="QnPanelId3T" className="QnPanel">
                                        <input
                                            type="image"
                                            id="imgPrc"
                                            src={principle_n}
                                            className="imgPrcT"
                                            alt="Principle"
                                            style={{ display: !okClicked && currentQnMeta?.NoOfPrc && currentQnMeta.NoOfPrc > 0 ? 'inline-block' : 'none' }}
                                            onClick={(e) => { e.preventDefault(); handlePrcClick(); }}
                                        />
                                    </td>
                                    <td id="QnPanelId4T" className="QnPanel">
                                        <input
                                            type="image"
                                            id="imgClue"
                                            src={clue_n}
                                            className="imgClueT"
                                            alt="Clue"
                                            style={{ display: !okClicked && Number(currentQnMeta?.NoOfClues || 0) > 0 ? 'inline-block' : 'none' }}
                                            onClick={(e) => { e.preventDefault(); handleClueClick(); }}
                                        />
                                    </td>
                                    <td id="QnPanelId5T" className="QnPanel">
                                        <input
                                            type="image" id="imgSoln" src={solutionSrc} className="imgSolnT" alt="Solution"
                                            style={{ display: currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0 ? 'inline-block' : 'none' }}
                                            onClick={(e) => { e.preventDefault(); handleSolnClick(false); }}
                                            onMouseOver={handleSolutionMouseOver}
                                            onMouseOut={handleSolutionMouseOut}
                                            onMouseDown={handleSolutionMouseDown}
                                        />
                                    </td>
                                    <td id="QnPanelId5T" className="QnPanel">
                                        <a
                                            href={`/STUDENT/Tutorials/Tutorial?id=${folderParam}&name=${encodeURIComponent(lessonName ?? '')}&folder=${encodeURIComponent(diccode ?? '')}&calledFrom=${encodeURIComponent(calledFrom ?? '')}&sessionId=${sessionId}&currentPage=${currentPage}`}
                                            id="imgbtnTut"
                                            className="imgbtnTutT"
                                            style={{ display: okClicked ? 'none' : 'inline-block' }}
                                        >
                                            <img src={tutorials_n} alt="Tutorial" id="imgbtnTut2T" />
                                        </a>
                                    </td>
                                    <td id="QnPanelId6T" className="QnPanel">
                                        {isSubmitting ? (
                                            <Loading />
                                        ) : okClicked ? (
                                            currentPage === totalPages ? (
                                                <img
                                                    src={doneSrc}
                                                    alt="Done"
                                                    style={{ verticalAlign: 'middle' }}
                                                    onClick={() => {
                                                        if (params.get('ViewLesson') === 'Y') {
                                                            const cf = params.get('CalledFrom') || params.get('calledFrom');
                                                            if (cf) {
                                                                window.location.href = decodeURIComponent(cf);
                                                            } else if (window.history.length > 1) {
                                                                window.history.back();
                                                            }
                                                            return;
                                                        }
                                                        handleDoneClick(() => {
                                                            const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
                                                            const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
                                                            const calledFrom = params.get("calledFrom") || "";
                                                            navigate(`/STUDENT/Tutorials/Result?DicCode=${dicCode}&LsnTestCode=${lsnTestCode}&SessionID=${sessionId}&source=lesson&complete=1` + (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : ""));
                                                        });
                                                    }}
                                                    onMouseOver={() => setDoneSrc(done_o)}
                                                    onMouseOut={() => setDoneSrc(done_n)}
                                                />
                                            ) : (
                                                <img
                                                    src={nextSrc}
                                                    alt="Next"
                                                    onClick={goToNextPage}
                                                    onMouseOver={handleNextMouseOver}
                                                    onMouseOut={handleNextMouseOut}
                                                    onMouseDown={handleNextMouseDown}
                                                    onMouseUp={handleNextMouseUp}
                                                    style={{ display: 'inline-block', cursor: 'pointer', marginTop: '3px' }}
                                                />
                                            )
                                        ) : (
                                            <div
                                                onClick={handleOkClick}
                                                onMouseOver={handleOkMouseOver}
                                                onMouseOut={handleOkMouseOut}
                                                onMouseDown={handleOkMouseDown}
                                                onMouseUp={handleOkMouseUp}
                                                style={{ display: 'inline-block', cursor: 'pointer' }}
                                            >
                                                <img src={okSrc} alt="OK" style={{ marginTop: '3px' }} />
                                            </div>
                                        )}
                                    </td>
                                    <td id="QnPanelId7" className="QnPanel">&nbsp;</td>
                                </tr>
                                <tr id="trQnNext" className="trQnNextT">
                                    <td id="tdBN1" className="QnPanel">&nbsp;</td>
                                    <td id="tdAnsMsg" className="QnPanel">&nbsp;</td>
                                    <td id="tdShowCA" className="QnPanel">&nbsp;</td>
                                    <td id="tdAnsSoln" className="QnPanel">
                                                                    <img id="imgSolnAfterAnswering" src={solutionSrc} alt="Solution"
                                            onClick={(e) => { e.preventDefault(); handleSolnClick(); }}
                                            onMouseOver={handleSolutionMouseOver} onMouseOut={handleSolutionMouseOut} onMouseDown={handleSolutionMouseDown} />
                                    </td>
                                    <td id="tdQnNext" className="QnPanel">
                                        {okClicked ? (
                                            <input type="image" id="imgNextQuestion" src={nextSrc} alt="Next"
                                                onClick={goToNextPage} onMouseOver={handleNextMouseOver} onMouseOut={handleNextMouseOut}
                                                onMouseDown={handleNextMouseDown} onMouseUp={handleNextMouseUp} style={{ display: okClicked ? 'inline-block' : 'none' }} />
                                        ) : (
                                            <img id="imgOK" src={okSrc} alt="OK" onClick={handleOkClick} onMouseOver={handleOkMouseOver}
                                                onMouseOut={handleOkMouseOut} onMouseDown={handleOkMouseDown} onMouseUp={handleOkMouseUp} className="imgOKT"
                                                style={{ display: okClicked ? 'none' : 'inline-block' }} />
                                        )}
                                    </td>
                                    <td id="tdBN" className="QnPanel">&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}

            <tr id="triFrame">
                <td id="tdFrameQnT" style={{ padding: 0, height: '100%' }}>
                    <div id="divFrameQn" style={{ height: 'calc(95vh - 50px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
                        {questionHtml ? (
                            <iframe
                                id="iFrameQn"
                                ref={iframeRef}
                                frameBorder={0}
                                scrolling="yes"
                                className="CssiFrm"
                                style={{
                                    flex: '1 1 0',
                                    width: '100%',
                                    height: '100%',
                                    minHeight: 0,
                                    border: 'none',
                                    overflow: 'auto'
                                }}
                                title="Question Page"
                                onLoad={() => {
                                    handleQuestionFrameLoad();
                                    handlePreviewLoad();
                                }}
                            />
                        ) : <Loading />}
                    </div>
                </td>
            </tr>

            {showClueModal && (
                <>
                    {!showSolnModal && <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowClueModal(false)}></div>}

                    <div id="divClue" style={{ display: 'block' }}>
                        <table id="tblTitleClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ height: "50px", fontSize: "15px" }}>
                            <tbody>
                                <tr>
                                    <td id="tdClueTitle1" align="left" style={{ paddingLeft: '30px', color: '#ffffff', fontWeight: 'bold' }}>Clue</td>
                                    <td id="tdClueClose" align="right" valign="top">
                                        <img
                                            id="imgClueClose"
                                            src={CloseBtnSrc}
                                            alt="Close"
                                            onClick={() => setShowClueModal(false)}
                                            onMouseOver={handleCloseBtnMouseOver}
                                            onMouseOut={handleCloseBtnMouseOut}
                                            style={{ cursor: 'pointer', padding: '5px', width: '30px', height: '30px', marginRight: '30px' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div id="divFrameClue">
                            {isClueLoading ? <Loading /> : (
                                <iframe
                                    id="iFrameClue"
                                    ref={clueIframeRef}
                                    title="Clue"
                                    srcDoc={clueContent}
                                    style={{ width: '100%', border: 'none', minHeight: '80px' }}
                                    onLoad={() => {
                                        const iframe = clueIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;
                                        try {
                                            const doc = iframe.contentDocument;

                                            const divShows = doc.querySelectorAll("[id^='divShow']");
                                            divShows.forEach(div => {
                                                (div as HTMLElement).style.padding = "20px";
                                            });

                                            const cluesInput = doc.getElementById('NoOfClues') as HTMLInputElement;
                                            const totalClues = parseInt(cluesInput?.value || '0', 10);
                                            setNoOfClues(totalClues);

                                            const clueDivs = doc.querySelectorAll<HTMLElement>('[id^="divShow"]');
                                            clueDivs.forEach((div, index) => div.style.display = index === 0 ? 'block' : 'none');

                                            const firstClueDiv = doc.getElementById('divShow1');
                                            if (firstClueDiv) {
                                                const newHeight = firstClueDiv.offsetHeight;
                                                iframe.style.height = `${Math.min(newHeight, 300)}px`;
                                            } else if (totalClues === 0) {
                                                iframe.style.height = '50px';
                                            }
                                        } catch (e) { console.error("Error inside clue iframe onLoad:", e); }
                                    }}
                                />
                            )}
                        </div>

                        <table id="tblNavClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2', height: '50px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '33%' }}>&nbsp;</td>
                                    <td style={{ width: '34%' }}>&nbsp;</td>
                                    <td align="right" style={{ width: '33%', paddingRight: '30px' }}>
                                        {!isClueLoading && noOfClues > 1 && currentClueNo < noOfClues - 1 && (
                                            <img
                                                id="btnClueNext"
                                                src={NextStepBtnSrc}
                                                alt="Next Clue"
                                                onClick={() => {
                                                    const nextClue = currentClueNo + 1;
                                                    const iframe = clueIframeRef.current;
                                                    if (iframe?.contentDocument) {
                                                        iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]').forEach((div, index) => {
                                                            div.style.display = index === nextClue ? 'block' : 'none';
                                                        });
                                                        setCurrentClueNo(nextClue);

                                                        const nextClueDiv = iframe.contentDocument.getElementById(`divShow${nextClue + 1}`);
                                                        if (nextClueDiv) {
                                                            const newHeight = nextClueDiv.scrollHeight + 20;
                                                            iframe.style.height = `${Math.min(newHeight, 300)}px`;
                                                        }
                                                    }
                                                }}
                                                onMouseOver={handleNextStepBtnMouseOver}
                                                onMouseOut={handleNextStepBtnMouseOut}
                                                style={{ cursor: 'pointer', width: '100px', height: '40px', marginTop: '5px' }}
                                            />
                                        )}
                                        {!isClueLoading && (noOfClues <= 1 || currentClueNo === noOfClues - 1) && (
                                            <img
                                                id="btnClueGotIt"
                                                src={GotItBtnSrc}
                                                alt="Got It"
                                                onClick={() => setShowClueModal(false)}
                                                onMouseOver={handleGotItBtnMouseOver}
                                                onMouseOut={handleGotItBtnMouseOut}
                                                style={{ cursor: 'pointer', display: isClueLoading ? 'none' : 'inline-block', width: '100px', height: '40px', marginTop: '5px' }}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {showPrcModal && (
                <>
                    <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowPrcModal(false)}></div>

                    <div id="divPCS" style={{ display: 'block' }} className="principle">

                        {/* Header */}
                        <table id="tblTitlePCS" className="principle" cellSpacing="0" cellPadding="0" width="100%">
                            <tbody>
                                <tr>
                                    <td id="tdPCSTitle1" style={{ paddingLeft: '15px', color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
                                        Principle {principleList.length > 1 ? ` ${currentPrcIndex + 1} of ${principleList.length}` : ''}
                                    </td>
                                    <td id="tdPCSClose" align="right" valign="top">
                                        <img
                                            id="imgPCSClose"
                                            src={CloseBtnSrc}
                                            alt="Close"
                                            onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                                            onMouseOver={handleCloseBtnMouseOver}
                                            onMouseOut={handleCloseBtnMouseOut}
                                            style={{ cursor: 'pointer', padding: '5px', width: '40px', height: '40px', marginRight: '30px' }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Body */}
                        <div id="divFramePCS">
                            {isPrcLoading ? <Loading /> : (
                                <iframe
                                    id="iFramePrc"
                                    ref={prcIframeRef}
                                    title="Prc"
                                    srcDoc={prcContent}
                                    style={{ width: '100%', border: 'none', overflow: 'hidden', display: 'block' }} // 2. Set overflow hidden initially
                                    onLoad={() => {
                                        const iframe = prcIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

                                        setTimeout(() => {
                                            if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                                            const contentHeight = iframe.contentDocument.body.scrollHeight + 20;

                                            const divPCS = document.getElementById('divPCS') as HTMLElement;
                                            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                            const navTable = document.getElementById('tblNavPCS') as HTMLElement;
                                            if (divPCS && titleTable && navTable) {
                                                const maxModalHeight = window.innerHeight * 0.8;
                                                const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;
                                                if (contentHeight > maxIframeHeight) {

                                                    iframe.style.height = `${maxIframeHeight}px`;
                                                    iframe.style.overflowY = 'auto';
                                                } else {

                                                    iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                                                    iframe.style.overflowY = 'hidden';
                                                }
                                            } else {
                                                iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                                            }
                                        }, 50);
                                    }}
                                />
                            )}
                        </div>

                        {/* Footer / Navigation */}
                        <table id="tblNavPCS" className="principle" cellSpacing="0" cellPadding="0" width="100%" style={{ height: '50px', fontSize: "15px" }}>
                            <tbody>
                                <tr style={{ backgroundColor: '#F2F2F2' }}>
                                    {/* Previous Button */}
                                    <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                                        {currentPrcIndex > 0 && (
                                            <input
                                                type='button'
                                                value='PREVIOUS'
                                                onClick={() => {
                                                    const prevIndex = currentPrcIndex - 1;
                                                    setCurrentPrcIndex(prevIndex);
                                                    const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                                                    const countryParam = params.get('country') || 'Australia';
                                                    fetchPrincipleContent(principleList[prevIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                                                }}
                                                style={{
                                                    fontWeight: 'bold',
                                                    color: 'White',
                                                    fontSize: '12pt',
                                                    borderStyle: 'none',
                                                    backgroundColor: 'maroon',
                                                    cursor: 'pointer',
                                                    padding: '5px 10px'
                                                }}
                                            />
                                        )}
                                    </td>

                                    <td style={{ width: '34%' }}>&nbsp;</td>

                                    {/* Next / Got It Button */}
                                    <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                                        {currentPrcIndex < principleList.length - 1 ? (
                                            <img
                                                src={NextStepBtnSrc}
                                                alt="Next"
                                                onClick={() => {
                                                    const nextIndex = currentPrcIndex + 1;
                                                    setCurrentPrcIndex(nextIndex);
                                                    const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                                                    const countryParam = params.get('country') || 'Australia';
                                                    fetchPrincipleContent(principleList[nextIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                                                }}
                                                onMouseOver={handleNextStepBtnMouseOver}
                                                onMouseOut={handleNextStepBtnMouseOut}
                                                style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                                            />
                                        ) : (
                                            <img
                                                src={GotItBtnSrc}
                                                id="imgGotIt"
                                                alt="Got It"
                                                onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                                                onMouseOver={handleGotItBtnMouseOver}
                                                onMouseOut={handleGotItBtnMouseOut}
                                                style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {showSolnModal && (
                <>
                    <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => {
                        setShowSolnModal(false);
                    }}></div>

                    <div id="divPCS" style={{ display: 'block', position: 'fixed', bottom: '0', width: '100%', zIndex: 10000 }}>
                        <table id="tblTitlePCS" className="solution" cellSpacing="0" cellPadding="0" width="100%">
                            <tbody>
                                <tr>
                                    <td id="tdPCSTitle1">Step by step solution</td>
                                    <td id="tdPCSClose" align="right" valign="top">
                                        <button
                                            type="button"
                                            aria-label="Close solution"
                                            onClick={() => setShowSolnModal(false)}
                                            style={{ width: '30px', height: '30px', margin: '5px 15px 5px 0', padding: 0, border: 0, borderRadius: 0, backgroundColor: '#ff6500', color: '#fff', fontSize: '18px', lineHeight: '30px', textAlign: 'center', cursor: 'pointer' }}
                                        >
                                            ×
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div id="divFramePCS">
                            {isSolnLoading ? <Loading /> : (
                                <iframe
                                    id="iFrameSolution"
                                    ref={solnIframeRef}
                                    title="Solution"
                                    srcDoc={solnContent}
                                    style={{ width: '100%', border: 'none', minHeight: '50px' }}
                                    onLoad={() => {
                                        const iframe = solnIframeRef.current;
                                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
                                            console.error("Iframe document or window not ready in onLoad.");
                                            return;
                                        }
                                        try {
                                            const iframeDoc = iframe.contentDocument;
                                            const stepsInput = iframeDoc.getElementById('NoOfSteps') as HTMLInputElement;
                                            const totalSteps = parseInt(stepsInput?.value || '0', 10);
                                            setNoOfSteps(totalSteps);

                                            const isAutoExpanded = iframeDoc.getElementById('IsAutoExpanded');

                                            const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                                            let firstStepHeight = 150;

                                            stepRows.forEach((step, index) => {
                                                if (index <= currentSolnNo || isAutoExpanded) {
                                                    step.style.display = 'table-row';
                                                } else {
                                                    step.style.display = 'none';
                                                }
                                            });

                                            if (totalSteps === 0) {
                                                iframe.style.height = '50px';
                                            }

                                            setTimeout(() => {
                                                if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                                                const contentHeight = iframe.contentDocument.body.scrollHeight + 5;

                                                const divPCS = document.getElementById('divPCS') as HTMLElement;
                                                const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                                const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                                                if (divPCS && titleTable && navTable) {
                                                    const maxModalHeight = window.innerHeight * 0.45;
                                                    const currentModalHeight = divPCS.offsetHeight;
                                                    const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;

                                                    if (contentHeight > maxIframeHeight) {
                                                        iframe.style.height = `${maxIframeHeight}px`;
                                                        iframe.style.overflowY = 'auto';
                                                    } else {
                                                        iframe.style.height = `${Math.max(contentHeight, 50)}px`;
                                                        iframe.style.overflowY = 'hidden';
                                                    }
                                                }

                                                if (isAutoExpanded) {
                                                    setCurrentSolnNo(totalSteps - 1);
                                                    if (solutionSeen !== 'Y') {
                                                        setSolutionSeen('Y');
                                                    }
                                                    iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);
                                                } else {
                                                    if (stepRows.length > 0) {
                                                        firstStepHeight = stepRows[0].scrollHeight + 5;
                                                        iframe.style.height = `${Math.max(firstStepHeight, 150)}px`;
                                                        iframe.style.overflowY = 'hidden';
                                                    }
                                                }
                                            }, 50);

                                            iframeDoc.querySelectorAll<HTMLImageElement>('img[id^="KsdImg"]').forEach(img => {
                                                const index = img.id.substring(6);
                                                const ksdDiv = iframeDoc.getElementById(`KsdDiv${index}`);
                                                const content = ksdDiv?.getAttribute('data-ksd-content');
                                                const wasPreviouslyRevealed = revealedSolnSteps.includes(Number(index));
                                                const parentTd = img.closest('td');

                                                if (content && parentTd && wasPreviouslyRevealed) {
                                                    parentTd.innerHTML = content;
                                                    img.setAttribute('alt', '2');
                                                    return;
                                                }

                                                img.onclick = () => {
                                                    if (content && parentTd && img.getAttribute('alt') === '1') {
                                                        parentTd.innerHTML = content;
                                                        img.setAttribute('alt', '2');
                                                        setRevealedSolnSteps(previous => previous.includes(Number(index)) ? previous : [...previous, Number(index)]);
                                                    }
                                                };
                                            });

                                        } catch (e) {
                                            console.error("Error inside solution iframe onLoad:", e);
                                        }
                                    }}
                                />
                            )}
                        </div>

                        <table id="tblNavPCS" className="solution" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
                            <tbody>
                                <tr>
                                    <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                                    </td>

                                    <td style={{ width: '34%' }}>
                                        &nbsp;
                                    </td>

                                    <td align="right" style={{ width: '33%', paddingRight: '15px' }}>

                                        {!isSolnLoading && noOfSteps > 0 && currentSolnNo < noOfSteps - 1 && (
                                            <img
                                                id="btnPCSNext"
                                                src={NextStepBtnSrc}
                                                alt="Next Step"
                                                onClick={() => {
                                                    const nextStep = currentSolnNo + 1;
                                                    const iframe = solnIframeRef.current;

                                                    if (iframe?.contentDocument?.body) {
                                                        const iframeDoc = iframe.contentDocument;

                                                        const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                                                        if (nextStep >= stepRows.length) return;

                                                        const nextStepElement = stepRows[nextStep];
                                                        nextStepElement.style.display = 'table-row';

                                                        setTimeout(() => {
                                                            if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                                                            const totalRequiredHeight = iframe.contentDocument.body.scrollHeight + 5;

                                                            const divPCS = document.getElementById('divPCS') as HTMLElement;
                                                            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                                            const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                                                            if (!divPCS || !titleTable || !navTable) return;

                                                            const maxModalHeight = window.innerHeight * 0.45;
                                                            const chromeHeight = titleTable.offsetHeight + navTable.offsetHeight;
                                                            const maxAllowedIframeHeight = maxModalHeight - chromeHeight;

                                                            if (totalRequiredHeight > maxAllowedIframeHeight) {
                                                                iframe.style.height = `${maxAllowedIframeHeight}px`;
                                                                iframe.style.overflowY = 'auto';
                                                            } else {
                                                                iframe.style.height = `${totalRequiredHeight}px`;
                                                                iframe.style.overflowY = 'hidden';
                                                            }

                                                            iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);

                                                        }, 50);

                                                        setCurrentSolnNo(nextStep);
                                                        if (solutionSeen !== 'Y') {
                                                            setSolutionSeen(nextStep + 1);
                                                        }
                                                    }
                                                }}
                                                onMouseOver={handleNextStepBtnMouseOver}
                                                onMouseOut={handleNextStepBtnMouseOut}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        )}

                                        {!isSolnLoading && (noOfSteps === 0 || currentSolnNo === noOfSteps - 1) && (
                                            <img
                                                id="btnPCSClose"
                                                src={GotItBtnSrc}
                                                alt="Got It"
                                                onClick={() => {
                                                    setShowSolnModal(false);
                                                    setSolutionSeen('Y');
                                                }}
                                                onMouseOver={handleGotItBtnMouseOver}
                                                onMouseOut={handleGotItBtnMouseOut}
                                                style={{ cursor: 'pointer', display: isSolnLoading ? 'none' : 'inline-block' }}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    );
};

export default forwardRef(NQns);
